import { enableDragScroll } from '../../tools/helpers';

class ThemenweltSlider {
  constructor(options = {}) {
    this.element = options.element;
    this.sliderWrapper = this.element.querySelector('.slider-wrapper');
  }

  init() {
    if (!this.sliderWrapper) {
      return;
    }

    enableDragScroll(this.sliderWrapper);
  }
}

export default ThemenweltSlider;
